import { render, staticRenderFns } from "./3_magazine.vue?vue&type=template&id=20925748&scoped=true&"
import script from "./3_magazine.vue?vue&type=script&lang=js&"
export * from "./3_magazine.vue?vue&type=script&lang=js&"
import style0 from "./3_magazine.vue?vue&type=style&index=0&id=20925748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20925748",
  null
  
)

export default component.exports